import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'redSanitizeHtml'
})
export class SanitizeHtmlPipe implements PipeTransform {
  private domSanitizer = inject(DomSanitizer);

  transform(value?: string | null | undefined) {
    return this.domSanitizer.bypassSecurityTrustHtml(value ?? '');
  }
}
